import Emoji from "@core-components/emoji/Emoji";
import Icon from "@core-components/icon/Icon";
import InfoCardGrid from "@core-components/info-card/InfoCardGrid";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import { Text } from "@mantine/core";

export const SmurfsNormalFeatures = () => {
  const { t } = useAppTranslation("pages.normal");
  const { t: commonT } = useAppTranslation("pages.handlevel");
  const { currentRegion } = useAppRegion();

  return (
    <>
      <SSHeadline
        props={{
          title: {
            fz: 24,
          },
        }}
        subTitle={
          <Text className="px-3 text-center font-bold font-inter text-primary-white">
            {t("headline.subTitle")}
          </Text>
        }
      >
        <SSWhiteText>
          {t("headline.title", { region: currentRegion.toUpperCase() })}{" "}
        </SSWhiteText>
        <Emoji.Rocket size={24} />
      </SSHeadline>
      <InfoCardGrid
        cards={[
          {
            icon: <Icon.FastDelivery />,
            title: commonT("features.instantDelivery.title"),
            text: commonT("features.instantDelivery.text"),
          },
          {
            icon: <Icon.Trophy />,
            title: commonT("features.rankedReady.title"),
            text: commonT("features.rankedReady.text"),
          },
          {
            icon: <Icon.Chat />,
            title: commonT("features.premiumSupport.title"),
            text: commonT("features.premiumSupport.text"),
          },
          {
            icon: <Icon.Shield />,
            title: commonT("features.lifetimeWarranty.title"),
            text: commonT("features.lifetimeWarranty.text"),
          },
          {
            icon: <Icon.OpenLock />,
            title: commonT("features.unverifiedEmail.title"),
            text: commonT("features.unverifiedEmail.text"),
          },
          {
            icon: <Icon.Basket />,
            title: commonT("features.bestPrice.title"),
            text: commonT("features.bestPrice.text"),
          },
        ]}
        cardsPerRow={3}
      />
    </>
  );
};
